import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, OccEndpointsService, PRODUCT_NORMALIZER } from '@spartacus/core';
import { map, catchError, of } from 'rxjs';
import { KB_PRODUCT_URL_NORMALIZER } from 'src/app/app.module';

@Injectable({
  providedIn: 'root'
})
export class OrderStatusService {
  searchData:any;
  constructor(private http:HttpClient, private occEndpointsService: OccEndpointsService,private converterService:ConverterService) { }

  getOrderStatusList(){
    return this.http.get(this.occEndpointsService.buildUrl('myaccount/orderstatus'));
  }

  search(payload, currentPage=0, sort='byDateDesc'){
    return this.http.post(this.occEndpointsService.buildUrl(`myaccount/orderstatus?currentPage=${currentPage}&sort=${sort}`),payload);
  }

  getOrderStatusDetails(code){
    return this.http.get(this.occEndpointsService.buildUrl(`myaccount/orderstatuscode?code=${code}`)).pipe(
      map((res: any) => {
        if (res) {          
          res.orderDetails = { ...res.orderDetails,
            entries:res.orderDetails.entries.map((x)=>
              {
               x.product= this.converterService.convert(x.product,PRODUCT_NORMALIZER);
               return x;
              } )
        };
      }
        return res;
      }),
      catchError((error) => {
        return of(null);
      })
    );
  }

  setSearchData(data){
    this.searchData = data;
  }

  getSearchData(){
    return this.searchData;
  }

  reorder(orderCode){   
    return this.http.post(this.occEndpointsService.buildUrl(`myaccount/reorder?orderCode=${orderCode}`),{});
  }
}
